///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

const ChevronRight = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 19">
    <path
      d="M.213 1.671a.692.692 0 01.98-.979L9.99 9.49l-8.798 8.797a.692.692 0 01-.979-.98L8.031 9.49.213 1.67z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

export default ChevronRight;
